module.exports = __WEBPACK_EXTERNAL_MODULE_react_trfq__;